// Strips Unicode combining marks (diacritics) after NFKD decomposition.
// Range U+0300–U+036F covers the Combining Diacritical Marks block.
const COMBINING_MARKS = /[̀-ͯ]/g;
const NON_ALNUM_RUN = /[^a-z0-9]+/g;
const TRIM_HYPHENS = /^-+|-+$/g;

const MAX_LEN = 63;
const MIN_LEN = 3;

/**
 * Derive a subdomain candidate from a free-text company name.
 * Returns '' when the cleaned result is shorter than MIN_LEN so we never
 * push a value that would fail the field's own min-length validation.
 */
export function slugifyToSubdomain(name: string): string {
  const cleaned = name
    .normalize('NFKD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .replace(NON_ALNUM_RUN, '-')
    .replace(TRIM_HYPHENS, '');

  const truncated = cleaned.slice(0, MAX_LEN).replace(TRIM_HYPHENS, '');
  return truncated.length >= MIN_LEN ? truncated : '';
}
